/** Composant VUE */
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
/** Class */
import Dictionary from '@/types/Dictionary';
import Pin from '@/types/FilterTree/Pin';

/** Composants API */
import axios from 'axios';
import { API_URL } from '@/App.settings';

/** Classe utilitaire pour officialLabels */
@Component({
    components: {}
})

export default class OfficialLabelsUtils extends Vue {

    /** Méthode de récupération des données du noeud sélectionné
    * @param pin Pin sélectionné
    */ 
    protected async getNodeInformations(pin: Pin): Promise<any> | undefined {
        if(pin){
            console.debug('OfficialLabels - getNodeInformation', pin);
            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["NodeId"] = pin.Selections[0];
            
            return await axios.post(API_URL + 'OfficialLabels/GetNodeInformations', args).then((response) => {
                if (response && response.data)
                    return response.data;
            }).catch (err => {
                console.error(err);{
                this.$bvToast.toast(this.$t('AnErrorOccuredContactAdmin').toString(), { // $t('AnErrorOccuredContactAdmin') / "Une erreur est survenue. Veuillez contacter votre administrateur.", {
                    title: this.$t('Error').toString(), // $t('Error') / "Erreur"
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-bottom-right"
                    });
                };
            });
        }
    }

    /** Méthode de récupération des données du type objet sélectionné 
    * @param objectType Type objet sélectionné
    */
    protected async getPreviewInformations(objectType: string): Promise<any> | undefined {
        console.debug('OfficialLabels - getPreviewInformations', objectType);
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["ObjectType"] = objectType;

        return await axios.post(API_URL + 'OfficialLabels/GetPreviewInformations', args).then((response) => {
            if (response && response.data)
                return response.data;
        }).catch (err => {
            console.error(err);{
            this.$bvToast.toast(this.$t('AnErrorOccuredContactAdmin').toString(), { // $t('AnErrorOccuredContactAdmin') / "Une erreur est survenue. Veuillez contacter votre administrateur.", {
                title: this.$t('Error').toString(), // $t('Error') / "Erreur"
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-bottom-right"
                });
            };
        });
    }
}